import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import "./Navbar.css";
import logo from "../assets/logo-ct-dark.png";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            <img src={logo} alt="ChipServer Logo" />
          </Link>
          <Link to="/" onClick={closeMenu}>
          <span>ChipServer</span>
          </Link>
        </div>

        {/* Hamburger Icon */}
        <button className="menu-toggle" onClick={toggleMenu}>
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Navigation Links */}
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          <li><Link to="/" onClick={closeMenu}>Home</Link></li>
          <li><Link to="/about" onClick={closeMenu}>Our Story</Link></li>
          <li><Link to="/store/" onClick={closeMenu}>Products</Link></li>
          <li><Link to="/portable-classroom" onClick={closeMenu}>Portable Classroom</Link></li>
          <li><Link to="/blog" onClick={closeMenu}>Blog</Link></li>
          <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
        </ul>

        {/* Get Started - Hidden on Mobile */}
        <Link to="/products" className="btn-primary desktop-only">
          Get Started
        </Link>
      </div>
    </nav>
  );
}
